import { SignUpProductEnum } from "components/Signup/flow/SignupFlow/types";
import {
  getEarliestAllowedStartDate,
  MONTHLY_BILLING_INTERVAL,
  YEARLY_BILLING_INTERVAL,
} from "utils/insurance";
import {
  getDefaultBillingDay,
  getDefaultCopay,
  getDefaultDeductible,
  getDefaultLimit,
  isOrg,
} from "utils/site";
import { formatDate, uuid } from "utils/utils";
import { Animal, Insurance } from "./types";

export const getDefaultHealthInsurance = (): Insurance => {
  return {
    id: uuid(),
    limit: getDefaultLimit(),
    deductible: getDefaultDeductible(),
    copay: getDefaultCopay(),
    billingInterval: MONTHLY_BILLING_INTERVAL,
    billingDay: getDefaultBillingDay(),
    drafts: null,
    startDate: formatDate(getEarliestAllowedStartDate().toISOString()),
    discountCode: "",
    product: SignUpProductEnum.health,
    policy: null,
    ...(isOrg("swe") && {
      insurely: {
        currentInsurelyPolicyIndex: 0,
        shouldCompare: false,
        cancelCompetitor: false,
      },
      breedersAddOn: false,
      showLifeInsurance: false,
      lifeLimit: 0,
      lifeUtilityAddOn: "",
      previousInsurance: null,
      selectedLimitAddon: 60_000_00,
      preexistingConditions: false,
    }),
    ...(isOrg("fra") && {
      preventiveCareAddOnLimit: 0,
    }),
  };
};

export const getGermanDefaultLiabilityInsuranceSettings =
  (): Partial<Insurance> => {
    return {
      limit: 10_000_000_00,
      deductible: 150_00,
      copay: 0,
      billingInterval: YEARLY_BILLING_INTERVAL,
      billingDay: getDefaultBillingDay(),
      product: SignUpProductEnum.liability,
    };
  };

export const getGermanDefaultHealthIsuranceSettings =
  (): Partial<Insurance> => {
    return {
      limit: getDefaultLimit(),
      deductible: getDefaultDeductible(),
      copay: getDefaultCopay(),
      billingInterval: MONTHLY_BILLING_INTERVAL,
      billingDay: getDefaultBillingDay(),
      product: SignUpProductEnum.health,
    };
  };

export const getGermanBaseInsuranceSettings = (): Partial<Insurance> => {
  return {
    id: uuid(),
    drafts: null,
    startDate: formatDate(getEarliestAllowedStartDate().toISOString()),
    policy: null,
  };
};

export const getGermanHealthInsurance = (): Insurance => {
  return {
    ...getGermanBaseInsuranceSettings(),
    ...getGermanDefaultHealthIsuranceSettings(),
  } as Insurance;
};

const getDefaultInsurance = () => {
  if (isOrg("ger")) {
    // German will add the remaining props on the product step
    return getGermanBaseInsuranceSettings();
  }

  return getDefaultHealthInsurance();
};

export const getDefaultAnimal = (insurance = getDefaultInsurance()): Animal => {
  return {
    id: uuid(),
    name: null,
    birthday: null,
    sex: null,
    sexSituation: null,
    access: null,
    breed: null,
    mixedBreedFHalf: null,
    mixedBreedSHalf: null,
    species: null,
    insurances: [insurance as Insurance],
    healthHistory: [],
    isDraft: true,
  };
};
